let util = {
    groups: [
        {code: '0101', name: '关联-集团内'},
        {code: '0102', name: '关联-集团外'},
        {code: '0201', name: '存货-境内出版'},
        {code: '0202', name: '存货-境内非出版'},
        {code: '0203', name: '存货-境外出版'},
        {code: '0204', name: '存货-境外非出版'},
        {code: '0300', name: '资产'},
        {code: '0400', name: '服务'},
        {code: '0500', name: '政府'},
    ]
};
util.getCompanyGroupName = (group)=>{
    let name = '';
    let len = util.groups.length;
    for(let i = 0; i < len; i++){
        if(util.groups[i].code == group){
            name = util.groups[i].name;
            break;
        }
    }
    return name;
};

export default util;